import { signal } from "@preact/signals";

export type VideoState = "paused" | "playing" | "buffering";

// STATE
export const videoState = signal<VideoState>("paused");
export const videoPlaybackRate = signal<number>(1);
export const videoSeekPosition = signal<number | null>(null);
export const timerRefreshInterval = signal<number>(10);

// ACTIONS
const noop = () => {};
export const playVideo = signal<() => void>(noop);
export const pauseVideo = signal<() => void>(noop);
export const seekVideo = signal<(time: number) => void>(noop);
